var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMoreVert = function SvgMoreVert(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 14,
    fill: "none",
    viewBox: "0 0 4 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M2.25 14q-.721 0-1.236-.514A1.7 1.7 0 0 1 .5 12.25q0-.721.514-1.236A1.7 1.7 0 0 1 2.25 10.5q.721 0 1.236.514Q4 11.528 4 12.25q0 .721-.514 1.236A1.7 1.7 0 0 1 2.25 14m0-5.25q-.721 0-1.236-.514A1.7 1.7 0 0 1 .5 7q0-.721.514-1.236A1.7 1.7 0 0 1 2.25 5.25q.721 0 1.236.514Q4 6.278 4 7q0 .721-.514 1.236a1.7 1.7 0 0 1-1.236.514m0-5.25q-.721 0-1.236-.514A1.7 1.7 0 0 1 .5 1.75q0-.721.514-1.236A1.7 1.7 0 0 1 2.25 0q.721 0 1.236.514Q4 1.03 4 1.75t-.514 1.236A1.7 1.7 0 0 1 2.25 3.5"
  })));
};
export default SvgMoreVert;